import axios from 'axios'
import { getApiBaseUrl } from '@/config/apiBase'

let csrfTokenCache: string | null = null
let csrfFetchPromise: Promise<string | null> | null = null

export function clearCsrfTokenCache(): void {
  csrfTokenCache = null
  csrfFetchPromise = null
}

async function fetchCsrfTokenOnce(): Promise<string | null> {
  const base = getApiBaseUrl()
  try {
    const { data } = await axios.get(`${base}/csrf-token`, {
      withCredentials: true,
      timeout: 8_000,
    })
    csrfTokenCache = data.data?.csrfToken ?? data.csrfToken ?? null
    return csrfTokenCache
  } catch (err) {
    if (axios.isAxiosError(err) && err.response?.status === 429) {
      await new Promise((r) => setTimeout(r, 1_500))
      try {
        const { data } = await axios.get(`${base}/csrf-token`, {
          withCredentials: true,
          timeout: 8_000,
        })
        csrfTokenCache = data.data?.csrfToken ?? data.csrfToken ?? null
        return csrfTokenCache
      } catch {
        return null
      }
    }
    return null
  }
}

/** Token CSRF com cache e deduplicação de requisições concorrentes */
export async function getCsrfToken(): Promise<string | null> {
  if (csrfTokenCache) return csrfTokenCache
  if (!csrfFetchPromise) {
    csrfFetchPromise = fetchCsrfTokenOnce().finally(() => {
      csrfFetchPromise = null
    })
  }
  return csrfFetchPromise
}
